import { OpenAPI } from '../api/generated/core/OpenAPI';

// GET /v2/api/bridge/download/{userId} streams the exe and requires no
// Authorization header, so a plain <a href> download works and the URL can be
// copied into a browser on the customer's Windows server. `userId` is the
// account owner's id (for subusers - the main account they act on behalf of).
// A function, not a constant: OpenAPI.BASE is only set by initializeOpenAPI(),
// after this module is loaded.
export const getWawiBridgeDownloadUrl = (userId: string): string =>
  `${OpenAPI.BASE}/v2/api/bridge/download/${userId}`;

// Poll GET /v2/api/user/ds/bridge/status at this cadence while the
// "Database connection" tab is open (no websockets by design).
export const WAWI_BRIDGE_STATUS_POLL_MS = 15000;
